export default "__VITE_ASSET__CVH93AIH__"